import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let _cache = null;
let _promise = null;

export const fetchSoftwareConfig = (force = false) => {
  if (_cache && !force) return Promise.resolve(_cache);
  if (!_promise || force) {
    _promise = axios
      .get(`${API}/software-config/effective`)
      .then((r) => { _cache = r.data; return _cache; })
      .catch(() => ({ tabs: null, fields: {} }));
  }
  return _promise;
};

export const invalidateSoftwareConfig = () => { _cache = null; _promise = null; };

export const useSoftwareConfig = () => {
  const [cfg, setCfg] = useState(_cache);
  useEffect(() => { let on = true; fetchSoftwareConfig().then((c) => on && setCfg(c)); return () => { on = false; }; }, []);
  return cfg;
};

export const useFieldCfg = (module) => {
  const cfg = useSoftwareConfig();
  const f = (cfg && cfg.fields && cfg.fields[module]) || {};
  return {
    ready: !!cfg,
    canEdit: (k) => (f[k] ? !!f[k].editable : true),
    label: (k, dflt) => (f[k] && f[k].label) || dflt,
  };
};
